import { useState } from 'react';
import { option } from '@code-expert/prelude';
export const useAsyncError = (name) => {
    const [error, setError] = useState(option.none);
    let hasBeenResetInThisRender = false;
    return {
        abort: (e) => {
            setError(option.some(e));
        },
        reset: () => {
            hasBeenResetInThisRender = true;
            if (option.isSome(error))
                setError(option.none);
        },
        raise: () => {
            if (option.isSome(error) && !hasBeenResetInThisRender)
                throw new Error(`Async effect ${name} failed`, { cause: error.value });
        },
    };
};
//# sourceMappingURL=useAsyncError.js.map